import { X } from "lucide-react";
import { type ReactElement, type ReactNode } from "react";

import { cn } from "../utils/cn";

export interface FilterChipProps {
  children: ReactNode;
  onRemove?: () => void;
  removeLabel?: string;
  className?: string;
}

export function FilterChip({
  children,
  onRemove,
  removeLabel = "Filter entfernen",
  className,
}: FilterChipProps): ReactElement {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full bg-neutral-100 py-1 pl-2.5 pr-1 text-sm text-neutral-700",
        className,
      )}
    >
      {children}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={removeLabel}
          className="inline-flex rounded-full p-1 text-neutral-500 hover:bg-neutral-200 hover:text-neutral-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
        >
          <X size={12} />
        </button>
      )}
    </span>
  );
}
